import React from "react";
import { Modal, Button } from "antd";
import FormCultureAttribute from "../formCultureAttribute/formCultureAttribute";

const ModalCultureAttribute = ({
    visible,
    onClose,
    states,
    setters,
    newCultureAttribute,
    saveCultureAttribute,
    createCultureAttribute,
    onDeleteAllBehaviors,
}) => {
    return (
        <Modal
            title={newCultureAttribute ? "Crear nuevo atributo cultural" : "Editar atributo cultural"}
            open={visible}
            onCancel={onClose}
            footer={null}
            width="80%"
            maskClosable={false}
        >
            <FormCultureAttribute
                {...states}
                {...setters}
                newCultureAttribute={newCultureAttribute}
                saveCultureAttribute={saveCultureAttribute}
                createCultureAttribute={createCultureAttribute}
                onDeleteAllBehaviors={onDeleteAllBehaviors}
            />
        </Modal>
    );
};

export default ModalCultureAttribute;